<template>
  <div class="container">
    <ScrollView class="nav-menu-wrapper pc" :style="wrapperStyle">
      <el-menu
        :default-active="activeIndex"
        class="menu"
        :class="mode"
        :mode="mode"
        @select="handleSelect"
        :background-color="config.menuBackgroundColor"
        :text-color="config.menuTextColor"
        :active-text-color="config.menuActiveTextColor"
        menu-trigger="hover"
      >
        <el-menu-item class="menu-item mobile" index="-1">
          <i class="iconfont iconguanbi"></i>
        </el-menu-item>
        <template v-for="(item, index) in menus">
          <el-menu-item v-if="item.subMenuList.length == 0" :key="item.id" :index="index + ''" class="menu-item"
            ><span>{{ item.title }}</span></el-menu-item
          >
          <el-submenu v-else :key="item.id" :index="index + ''" class="menu-item" :popper-class="menuClass">
            <template slot="title">
              <span @click="handleSelect(index + '')">{{ item.title }}</span>
            </template>

            <el-menu-item v-for="(subMenu, index2) in item.subMenuList" :key="index2" :index="index + '-' + index2" v-show="!subMenu.isHidden" class="menu-item">{{ subMenu.title }}</el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
      <i class="iconfont iconcaidan mobile" @click="handleOpen"></i>
    </ScrollView>

    <div class="nav-menu-wrapper mobile">
      <el-menu
        :default-active="activeIndex"
        class="menu"
        :class="mode"
        :mode="mode"
        @select="handleSelect"
        :background-color="config.menuBackgroundColor"
        :text-color="config.menuTextColor"
        :active-text-color="config.menuActiveTextColor"
        menu-trigger="hover"
      >
        <el-menu-item class="menu-item mobile" index="-1">
          <i class="iconfont iconguanbi"></i>
        </el-menu-item>
        <template v-for="(item, index) in menus">
          <el-menu-item v-if="item.subMenuList.length == 0" :key="item.id" :index="index + ''" class="menu-item"
            ><span>{{ item.title }}</span></el-menu-item
          >

          <el-submenu v-else :key="item.id" :index="index + ''" class="menu-item" :popper-class="menuClass">
            <template slot="title">
              <span>{{ item.title }}</span>
            </template>

            <el-menu-item v-for="(subMenu, index2) in item.subMenuList" :key="index2" :index="index + '-' + index2" v-show="!subMenu.isHidden" class="menu-item">{{ subMenu.title }}</el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
      <i class="iconfont iconcaidan mobile" @click="handleOpen"></i>
    </div>
  </div>
</template>

<script>
import ScrollView from '@/components/ScrollView.vue'
import util from '@/libs/util.js'
export default {
  name: 'NavMenu',
  props: {
    menuClass: String,
    config: {
      type: Object,
      default: function() {
        return {
          backgroundColor: '#ffffff',
          textColor: '#303133',
          activeTextColor: '#409EFF'
        }
      }
    },
    menus: {
      type: Array,
      default: function() {
        return [
          {
            id: 1,
            title: '首页',
            type: 1,
            content: './portal',
            activePaths: [],
            subMenus: [],
            userInfo: null
          }
        ]
      }
    }
  },
  data() {
    return {
      activeIndex: '',
      wrapperStyle: {},
      mode: 'horizontal'
    }
  },
  created() {
    this.init()
  },
  watch: {
    $route(/* to, from */) {
      this.init()
    }
  },
  methods: {
    init() {
      this.wrapperStyle = {
        color: this.config.textColor,
        backgroundColor: this.config.backgroundColor
      }
      var index = this.getMenuByRoute()
      if (index) {
        var indexs = index.split('-')
        if (indexs.length > 2) {
          this.activeIndex = indexs[0] + '-' + indexs[1]
        } else {
          this.activeIndex = index
        }
      } else {
        this.activeIndex = ''
      }
      // var menu = this.getMenuByIndex(this.activeIndex);
      // if (menu && menu.title != "首页") {
      //   util.setTitle(menu.title);
      // }
    },
    handleSelect(key /* , keyPath */) {
      // 分类型处理
      if (key != -1) {
        var menu = this.getMenuByIndex(key)
        switch (menu.type) {
          case 1:
            if (menu.content) {
              this.$router.push(menu.content)
              this.activeIndex = key
              this.handleClose()
            }
            break
          case 2:
            // 外链
            window.open(menu.content)
            this.activeIndex = key
            this.handleClose()
            break
          case 3:
            //福建开放大学单独设置
            var userInfo = util.getCookie('USER_INFO')
            if (userInfo) {
              this.userInfo = JSON.parse(userInfo)
              if (this.userInfo.userId) {
                this.homePage()
              } else {
                this.$EventBus.$emit('showLoginFlag', true)
              }
            } else {
              this.$EventBus.$emit('showLoginFlag', true)
            }
            break
        }
      } else {
        this.handleClose()
        this.$nextTick(() => {
          this.init()
        })
      }
    },
    homePage() {
      switch (this.userInfo.roleId) {
        case 182:
        case 183:
          util.UMOOC_SERVER_HOST + '/admin'
          break
        case 184:
          window.location = util.UMOOC_SERVER_HOST + '/umooc/service/service.do?operation=toolKit'
          break
        case 250:
          window.location = `https://ua${util.UMOOC_COOKIE_DOMAIN}/createCourse/#/main/courseList/editing`
          break
        case 8:
          window.location = util.UMOOC_SERVER_HOST + '/umooc/tutorv2/tutorManage.do?operation=index'
          break
        case 9:
          window.location = util.UMOOC_SERVER_HOST + '/umooc/learner/learner.do?operation=index'
          break
        default:
          window.location = util.UMOOC_SERVER_HOST + '/umooc/learner/learner.do?operation=index'
      }
    },
    getMenuByIndex(key) {
      var indexs = key.split('-')
      var menu = this.menus
      if (indexs.length > 1) {
        menu = menu[indexs[0]].subMenuList[indexs[1]]
      } else {
        menu = menu[indexs[0]]
      }
      return menu
    },
    getMenuByRoute() {
      for (var i = 0; i < this.menus.length; i++) {
        var menu = this.menus[i]
        if (menu.isActive(this.$route)) {
          return i + ''
        }
        for (var j = 0; j < menu.subMenuList.length; j++) {
          var subMenu = menu.subMenuList[j]
          if (subMenu.isActive(this.$route)) {
            return i + '-' + j
          }
          if (subMenu.subMenuList) {
            for (var z = 0; z < subMenu.subMenuList.length; z++) {
              var lastMenu = subMenu.subMenuList[z]
              if (lastMenu.isActive(this.$route)) {
                return i + '-' + j + '-' + z
              }
            }
          }
        }
      }
    },
    changeActive(item) {
      if (item.content) {
        this.activeIndex = this.getMenuIndex(item.content)
      }
    },

    handleOpen() {
      this.mode = 'vertical'
      this.$emit('getFlag', true)
    },
    handleClose() {
      this.mode = 'horizontal'
      this.$emit('getFlag', false)
    }
  },
  components: {
    ScrollView
  }
}
</script>
<style lang="scss">
.nav-menu {
  margin-left: auto;
  margin-right: auto;
  line-height: 50px;
  height: 50px;
  border-bottom: unset !important;
  overflow: hidden;
  font-size: 0;
  .menu-item {
    float: none;
    display: inline-block;
    height: 50px !important;
    line-height: 50px !important;
    border: unset;
  }
  .menu-item .el-submenu__title {
    height: 50px !important;
    line-height: 50px !important;
    border: unset;
  }

  .menu-item .el-submenu__title .el-submenu__icon-arrow {
    display: none;
  }
  .nav-menu-wrapper {
    width: auto;
    max-width: 100%;
  }
}
@media (max-width: 767px) {
  .menu-item .el-submenu__title span {
    padding-right: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .nav-menu-wrapper {
    margin-top: unset;
    overflow: unset;
  }

  .menu {
    text-align: unset;
    border-radius: 0;
  }

  .menu .menu-item {
    display: list-item;
    text-align: left;
  }

  .menu-item {
    display: list-item !important;
  }

  .menu-item.is-opened {
    height: auto;
  }

  .menu.vertical {
    display: unset !important;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    height: 100%;
    padding: 0;
    overflow: auto;
    border-right: unset !important;
  }
  .hnkc .menu.vertical {
    display: unset !important;
    position: fixed;
    z-index: 100;
    top: 0;
    left: unset;
    right: 0;
    height: 100%;
    padding: 0;
    overflow: auto;
    border-right: unset !important;
  }
  .menu.horizontal {
    display: none;
  }
  .menu .menu-item .el-submenu__title .el-submenu__icon-arrow {
    display: unset;
  }
}

.hnkc .iconguanbi {
  color: unset;
}
.hnwgy .iconguanbi {
  color: unset;
}
.kcsz .iconcaidan {
  font-size: 20px;
  margin-left: -15px;
  color: #888;
}
</style>
